module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "ChangeLifeCouponView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChangeLifeCouponView!./src/pages/Shop/Member/Wallet/ChangeLifeCoupon/indexView.js
// module id = 1071
// module chunks = 431